import { BaseView } from '../../../shared/utils/baseComponent'
import template from './reset-password.component.pug'
import css from './reset-password.component.scss'

class ResetPasswordController extends BaseView {
  constructor($element, $state, $http) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $state, $http },
      {
        sent: false,
      },
    )
  }

  sendResetPasswordLink() {
    const email = this.email
    return this.$http({
      method: 'PATCH',
      url: '/api/users/password',
      params: { email },
    })
      .then(() => {
        this.sent = true
      })
      .catch((err) => {
        console.error('err', err)
      })
  }
}

export const resetPasswordComponent = {
  controller: ResetPasswordController,
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/account/containers/reset-password/reset-password.component.js